import React from 'react'
import styles from '../navbar.module.scss'
import BtnPrimary from 'components/generic/BtnPrimary'
import i18n from 'constants/strings'
import { ReactComponent as EmailIcon } from 'images/icons/icn_email.svg'
import { WALK_UP_REG_HREF } from 'constants/global'
import { SubPaths } from 'components/profile/ProfileRouter/ProfileRouter'
import { getOwnProfileUrlWithoutOrigin } from 'utils'

export const RegisterBtn = () => {
  return (
    <BtnPrimary href={WALK_UP_REG_HREF} className={styles.btn}>
      {i18n.t('strCommonUI.button.register')}
    </BtnPrimary>
  )
}

export const Subscribe = () => {
  return (
    <BtnPrimary className={styles.btn} controlSubscribeModal>
      <EmailIcon className={styles.btnIcon} />
      {i18n.t('strCommonUI.button.subscribe')}
    </BtnPrimary>
  )
}
export const PostScore = () => {
  // Build the URL as a string with the desired hash.
  const href = `${getOwnProfileUrlWithoutOrigin()}${SubPaths.PostScore}`

  return (
    <div>
      <a href={href} className={styles.navLink}>
        {i18n.t('strCommonUI.button.postAScore')}
      </a>
      <span className={styles.newLabel}>{i18n.t('strCommonUI.button.new')}</span>
    </div>
  )
}
